import React, { useState, useEffect } from "react";
import CollegeProfile from "../College/CollegeProfile";
import CollegeHomeContainer from "../Container/CollegeHomeContainer";
import { connect } from "react-redux";
import { API } from '../../API';

const CollegePreviewProfile = (props) => {
  const [isUploadPopup, setIsUploadPopup] = useState(false);
  const [qualificationList, setQualificationList] = useState([])
  const [selectedList, setSelectedList] = useState([])
  const [selectedByQualification, setSelectedByQualification] = useState({})

  const toggleUpload = (e) => {
    setIsUploadPopup(true);
  };

  const tabs = [
    {
      text: "Institute Profile",
      active: true,
    },
  ];

  useEffect(() => {
    API.getQualificationList().then(result => {
      const qualifications = result?.data?.data
      setQualificationList(qualifications)

      // check selectedList
      const { selected_can_delivers } = props.institution
      const selectedItem = {}
      const selectedByQualification = {}
      qualifications.forEach(item => {
          const quaList = item.qualifications
          if(item.type === 'vet') {
              quaList.forEach(qua => {
                  const { units } = qua
                  units.forEach(unit => {
                      if(selected_can_delivers.includes(unit._id)) {
                          const key = `${qua.title}_keyID:${qua._id}`
                          const unitItem = `${unit.title}_id:${unit._id}`
                          if(selectedItem[key]?.length) {
                              if(!selectedItem[key]?.includes(unitItem)) {
                                  selectedItem[key].push(unitItem)
                              }
                          }
                          else {
                              selectedItem[key] = [unitItem]
                          }

                          if(selectedByQualification[qua._id]?.length) {
                              selectedByQualification[qua._id].push(unit._id)
                          }
                          else {
                              selectedByQualification[qua._id] = [unit._id]
                          }
                      }
                  })
              })
          }
          else {
              const key = `${item.qualification_name}_keyID:${item._id}`
              quaList.forEach(qua => {
                  const quaItem = `${qua.title}_id:${qua._id}`
                  if(selected_can_delivers.includes(qua._id)) {
                      if(selectedItem[key]?.length) {
                          if(!selectedItem[key]?.includes(quaItem)) {
                              selectedItem[key].push(quaItem)
                          }
                      }
                      else {
                          selectedItem[key] = [quaItem]
                      }
                  }
              })
          }
      })
      setSelectedList(selectedItem)
      setSelectedByQualification(selectedByQualification)
    })
  }, [])

  return (
    <CollegeHomeContainer
      institution={props.institution}
      tabs={tabs}
      isViewAsCollege={false}
      isShowUploadAvatar={false}
      tabProfileActive={true}
      uploadAvatar={toggleUpload}
      offset={true}
      removeTopMargin={true}
    >
      <CollegeProfile
        user={props.user}
        campuses={props.campuses}
        personnels={props.personnel}
        institution={props.institution}
        isViewAsCollege={false}
        selectedItem={selectedList}
        selectedCanDelivers={props.institution.selected_can_delivers}
        qualifications={qualificationList}
        selectedByQualification={selectedByQualification}
      />
    </CollegeHomeContainer>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.college.user,
    institution: state.college.institution,
    campuses: state.college.campuses,
    personnel: state.college.personnel,
  };
};

export default connect(mapStateToProps)(CollegePreviewProfile);
